import { render, staticRenderFns } from "./BidInvoiceJobModal.vue?vue&type=template&id=596e24ce&scoped=true&"
import script from "./BidInvoiceJobModal.vue?vue&type=script&lang=js&"
export * from "./BidInvoiceJobModal.vue?vue&type=script&lang=js&"
import style0 from "./BidInvoiceJobModal.vue?vue&type=style&index=0&id=596e24ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e24ce",
  null
  
)

export default component.exports